module.exports = __webpack_public_path__ + "img/20210906-1630898521489968.d6af444b.jpg";